export default __webpack_public_path__ + "static/media/444444.1ca24963.png";